import React from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import DropDown from 'components/sales/Input/dropdown1/dropDown.js'
import './divLayout.css';
import { getDetails } from 'services/redux/sales/preSaleListing/action';
const DivLayout = ({
  heading,
  data,
  size,
  fullWidth = false,
  status = false,
  spanClass = '',
  parentClass = '',
  display = false,
  lcx=false,
  headingClass='',
  mkClass=''
}) => {
  function changeDisplay() {
    display = !display;
    if (size !== undefined) {
      for (let i = 0; i < size; i++) {
        if (display) {

          document.getElementsByClassName("display-description")[i].style.display = "block";
        }
        else {
          document.getElementsByClassName("display-description")[i].style.display = "none";

        }
      }
    }
  }

  return (

    <div
      className={`${fullWidth ? 'details-list full-width' : lcx ? 'details-list col-md-6' : mkClass ? mkClass : 'details-list'} ${parentClass}`}
    >
      <strong className={`${lcx ? 'data-title lcx-msg' : 'data-title'} ${headingClass}`}>{heading}</strong>
      <span className={`data-details ${spanClass}`}>
        {status ? (
          <span
            className={data ? `${data.toLowerCase()} status-td` : 'status-td'}
          >
            {data ? data : localization.na}
          </span>
        ) : data ? (
          heading !== 'Description' ? data : (<div>
            <svg onClick={changeDisplay} style={{ cursor: 'pointer' }} width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="6.5" cy="6.5" r="5.5" stroke="#00163E" />
              <path d="M6.50137 4.09C6.3347 4.09 6.1947 4.03333 6.08137 3.92C5.96803 3.80667 5.91137 3.67 5.91137 3.51C5.91137 3.35 5.96803 3.21333 6.08137 3.1C6.1947 2.98 6.3347 2.92 6.50137 2.92C6.66137 2.92 6.79803 2.98 6.91137 3.1C7.0247 3.21333 7.08137 3.35 7.08137 3.51C7.08137 3.67 7.0247 3.80667 6.91137 3.92C6.79803 4.03333 6.66137 4.09 6.50137 4.09ZM6.93137 10H6.06137V5H6.93137V10Z" fill="#00163E" />
            </svg>
            <p className="display-description">{data}</p>
          </div>)
        ) : (
          localization.na
        )}
      </span>
    </div>
  );
};



DivLayout.propTypes = {
  heading: PropTypes.string,
  data: PropTypes.any,
  fullWidth: PropTypes.bool,
  size: PropTypes.any
};

export default DivLayout;
